import { motion } from "motion/react";

type QuinnPanelBackdropProps = {
    onClose: () => void;
};

export function QuinnPanelBackdrop({ onClose }: QuinnPanelBackdropProps) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={onClose}
            className="fixed inset-0 z-[55] bg-gray-900/20 backdrop-blur-[1px]"
            aria-hidden="true"
        />
    );
}
